import React from "react";
import { connect } from "react-redux";

import { bindActionCreators, Dispatch } from "redux";

import { INotification } from "infrastructure/notification";
import { IAppNotificationState, appNotificationActions } from "ui/app";
import { Banner as BannerComponent } from "ui/components";

export interface IBannerProps {
  messages?: INotification[];
  appMessages?: INotification[];
  useAppNotification?: boolean;
  removeAppNotificationAction: (messageIndex: number) => void;
  removeScreenNotificationAction: (messageIndex: number) => void;
  messageClassName?: string;
  shouldScroll?: (message: INotification) => boolean;
}

export const Banner: React.FC<IBannerProps> = ({
  messages,
  appMessages,
  useAppNotification,
  removeAppNotificationAction,
  messageClassName,
  removeScreenNotificationAction,
  shouldScroll
}) => {
  if (useAppNotification) {
    return <BannerComponent shouldScroll={shouldScroll} messages={appMessages} removeNotificationAction={removeAppNotificationAction} messageClassName={messageClassName} />;
  } else {
    return <BannerComponent shouldScroll={shouldScroll} messages={messages} removeNotificationAction={removeScreenNotificationAction} messageClassName={messageClassName} />;
  }
};

export default connect(
  (state: { appNotification: IAppNotificationState }) => {
    return {
      appMessages: state.appNotification.messages
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators(
      {
        removeAppNotificationAction: appNotificationActions.removeAppNotification,
        removeScreenNotificationAction: appNotificationActions.removeScreenNotification
      },
      dispatch
    );
  }
)(Banner);
